import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { encryptedKeyByRsaKeyValidator, groupNameValidator, principalIdValidator, publicKeyValidator, signedEntityByRsaKeyValidator, } from '#validation';
export const groupCryptoSchema = z.object({
    publicKey: publicKeyValidator,
    sGroupByAdminKey: signedEntityByRsaKeyValidator,
    ePrivateKeyByAdminKey: encryptedKeyByRsaKeyValidator,
    ePrivateKeyBySsoGroupsKey: encryptedKeyByRsaKeyValidator.nullish(),
});
export const groupCreateSchema = groupCryptoSchema.extend({
    principalId: principalIdValidator({
        requiredError: 'group.principalId.required',
        formatError: 'group.principalId.uuid',
        forbiddenError: 'group.principalId.forbidden',
    }),
    name: groupNameValidator,
});
export class GroupCreateDto extends createZodDto(groupCreateSchema) {
}
